// ============================================================
// caseTeam.ts — "is this person ON the case?" (pure; tested in caseDobTeam.test.ts).
// Mirrors backend/src/lib/caseTeam.ts. Every way of being assigned counts:
// the OWNER / lead fee earner (assignedToUserId) and every member of the
// HANDLING TEAM / co-assignees (assignees), however many. Firm-wide
// visibility is NOT being on the case.
// ============================================================
export const isOnCaseTeam = (
  userId: string | null | undefined,
  c: { assignedToUserId: string | null; assignees?: { userId: string }[] | null } | null | undefined,
): boolean =>
  !!userId && !!c && (c.assignedToUserId === userId || (c.assignees ?? []).some((a) => a.userId === userId))
